import {notificationCatalog,noticeTone,type NoticeTone} from './noticeCatalog';
import type {UiConfiguration} from './config';

export type NoticePresentation={layout:'context'|'inline'|'screen';dismissible:boolean;enabled:boolean;durationMilliseconds?:number|null};
const definitions=new Map(notificationCatalog.entries.map(entry=>[entry.key,entry]));

// The event producer owns the draw/receipt identity and authoritative condition.
// This single resolver owns allowed presentation and lifetime. Admin configuration
// cannot change a financial result. Timeouts affect only the visible message.
export function resolveNotification(ui:UiConfiguration,key?:string,contextLayout:'inline'|'screen'='inline',fallbackTone:NoticeTone='info'){
 const definition=key?definitions.get(key):undefined;
 const choice=(ui.noticePresentation as Record<string,NoticePresentation>)[key??''];
 const chosen=choice?.layout;
 const layout=chosen&&chosen!=='context'&&definition?.layouts.includes(chosen)?chosen:contextLayout;
 return {
  tone:noticeTone(key,fallbackTone),layout,
  enabled:!definition?.optional||choice?.enabled!==false,
  dismissible:choice?.dismissible??true,
  durationMs:choice?.durationMilliseconds??ui.controls.noticeSuccessDurationMilliseconds
 };
}
